import { MutableRefObject } from 'react'
import { useEffect } from 'react'

const useClickAwayListener = (
  ref: MutableRefObject<Element>,
  clickAwayHandler: () => void
): void => {
  useEffect(() => {
    const handleClickAway = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        clickAwayHandler()
      }
    }

    document.addEventListener('mousedown', handleClickAway)
    return () => {
      document.removeEventListener('mousedown', handleClickAway)
    }
  }, [ref])
}

export default useClickAwayListener
